import styled from 'styled-components';
import { zIndex } from 'tokens';

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.85);
	backdrop-filter: blur(8px);
	z-index: ${zIndex.blockingModal};
	display: flex;
	align-items: center;
	justify-content: center;
	animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);

	@keyframes overlayShow {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`;

export const ModalContainer = styled.div`
	max-width: 800px;
	width: 100%;
	background: ${(p) => p.theme.white};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 20px;
	padding: 38px;
	box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);
	position: relative;
	max-height: 90vh;
	overflow-y: auto;
	animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);

	@keyframes contentShow {
		from {
			opacity: 0;
			transform: scale(0.96);
		}
		to {
			opacity: 1;
			transform: scale(1);
		}
	}

	@media (max-width: 768px) {
		padding: 28px;
		max-width: calc(100vw - 32px);
		max-height: calc(100vh - 32px);
	}
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 24px;
	right: 24px;
	width: 32px;
	height: 32px;
	background: transparent;
	border: none;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${(p) => p.theme.gray[600]};
	font-size: 24px;
	opacity: 0.7;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 1;
	}

	&:focus {
		outline: none;
	}
`;

export const Header = styled.div`
	text-align: center;
	margin-bottom: 34px;
`;

export const Headline = styled.h1`
	font-size: 27px;
	font-weight: 600;
	letter-spacing: -0.02em;
	color: ${(p) => p.theme.gray[1000]};
	margin: 0 0 12px 0;
`;

export const Subheading = styled.p`
	font-size: 15px;
	font-weight: 400;
	color: ${(p) => p.theme.gray[600]};
	line-height: 1.5;
	margin: 0;
`;

export const BillingToggle = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 28px;
`;

export const PricingGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 24px;
	margin-bottom: 32px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const TrialSection = styled.div`
	text-align: center;
	padding-top: 28px;
	border-top: 1px solid ${(p) => p.theme.gray[200]};
`;

export const TrialText = styled.p`
	color: ${(p) => p.theme.gray[600]};
	font-size: 14px;
	line-height: 1.6;
	margin: 0 0 16px 0;

	a {
		color: ${(p) => p.theme.blue[500]};
		text-decoration: none;
		font-weight: 500;
		transition: opacity 0.2s ease;

		&:hover {
			opacity: 0.8;
			text-decoration: underline;
		}
	}
`;

export const SecondaryLinks = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
	margin-top: 16px;
	flex-wrap: wrap;
`;

export const SecondaryLink = styled.a`
	color: ${(p) => p.theme.blue[600]};
	font-size: 14px;
	text-decoration: none;
	transition: color 0.2s ease;
	cursor: default;

	&:hover {
		color: ${(p) => p.theme.blue[400]};
	}
`;

export const LinkSeparator = styled.span`
	color: ${(p) => p.theme.gray[400]};
	font-size: 14px;
`;

export const MaybeLater = styled.button`
	background: transparent;
	margin-left: -4px;
	border: none;
	color: ${(p) => p.theme.gray[600]};
	font-size: 14px;
	transition: color 0.2s ease;

	&:hover {
		color: ${(p) => p.theme.gray[800]};
	}
`;
